import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    label: ({ matchCount }: {
        matchCount: number;
    }) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Accessibility label for viewing transcript match in context */
            label: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ matchCount }: {
                        matchCount: number;
                    }): string => __intl__.intl().formatMessage({ id: "TranscriptionMatchQS.label?c=3a7fythp21nq8", defaultMessage: "View transcript match {matchCount} in context" }, { matchCount: matchCount }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
